import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { httpService } from './http.service';
import { MessageService } from './message.service';
import { ErrorHandlerService } from './errorHandler.service';

export interface MyTicketsItem {
    ticketName: string;
    description: string;
    dueDate?: Date;
    department: string;
    url: string;
}

@Injectable({
    providedIn: 'root',
})
export class MyTicketsService extends httpService {
  private apiBase: string = 'api/mytickets';
  private apiUrl: string;

  constructor(messages: MessageService, errorHandler: ErrorHandlerService, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    super(errorHandler, messages);
    this.serviceName = "Order";

    this.apiUrl = this.baseUrl + this.apiBase;
  }

    getMyTickets(pageIndex = 0): Observable<MyTicketsItem[]> {
        return this.http.get<MyTicketsItem[]>(this.apiUrl + '/getMyTickets', {
            params: {
                pageIndex: pageIndex.toString(),
            }
        });
    }
}